import { PageHeader } from '@kc-console/shared-ui';

import EventDateFilter from './EventDateFilter';
import { useEventsController } from './EventsControllerProvider';
import EventUnsolvedBanner from './EventUnsolvedBanner';

import { getRouterConfig } from '@/shared/config/routes';
import useBreadcrumbItemsWithRegion from '@/shared/hooks/useBreadcrumbItemsWithRegion';
import { RssFeedButton } from '@/shared/ui';

const EventsHeaderView = () => {
  const breadcrumbs = useBreadcrumbItemsWithRegion(getRouterConfig());
  const { bannerState } = useEventsController();

  return (
    <>
      <PageHeader breadcrumbs={breadcrumbs} title="이벤트 내역" mainActions={<RssFeedButton />} />
      <EventDateFilter />
      <EventUnsolvedBanner {...bannerState} />
    </>
  );
};

export default EventsHeaderView;
